<template>
  <v-container>
    <v-layout mt-5 xs8>
      <v-flex column wrap xs12 sm12 md11 lg10 xl10>
        <h3>
          <v-icon large color="yellow">vpn_key</v-icon>
          Reset Password
        </h3>
        Enter your email address and we'll send you an email with a link to
        reset your password.
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 sm12 md11 lg10 xl10>
        <reset-password-form
          class="pl-5 pr-5 pb-3 pt-2 mt-4"
        ></reset-password-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ResetPasswordForm from "@/components/ResetPasswordForm.vue";

export default {
  components: {
    ResetPasswordForm
  }
};
</script>
